export enum PermissionMessengerOption {
  MESSENGER_COMMON_LOGIN = 'mensajeria',
}
